import TabellaQuoteCertificatoView from "./TabellaQuoteCertificatoView";
import {getQuoteApi} from "../../../../../../services/QuoteServices";
import {useContext, useEffect, useState} from "react";
import {LoaderContext} from "../../../../../../context/LoaderContext";

export default function TabellaQuoteCertificatoController({
                                                              certificato,
                                                          }) {

    const [quote, setQuote] = useState([]);

    const {startChiamata, endChiamata} = useContext(LoaderContext);

    async function getQuote(idCertificato) {
        startChiamata();

        const response = await getQuoteApi({
            quoteVeicoli: '1',
            attiva: '1',
            id_certificato: idCertificato
        });
        setQuote(response.data.data);
        endChiamata();
    }

    useEffect(() => {
        if (certificato) {
            getQuote(certificato.id_certificato);
        }
    }, [certificato]);

    return (
        <TabellaQuoteCertificatoView
            certificato={certificato}
            quote={quote}
        />
    );
}